import React from 'react'
import styled from 'styled-components'
import ReactLoading from 'react-loading';

const ButtonEl = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 100%;
    border: none;
    outline: none;
    color: white;
    font-family: "Poppins";
    font-weight: 500;
    font-size: 1rem;
    border-radius: 50px;
    background-color: black;


`
const Button = ({name,onClick,animation}) => {
    return(

        <ButtonEl onClick={onClick}>{
        animation == true 
        ?
        <ReactLoading type={"bars"} color={"white"}  height={40} width={40} />
        : name
        }
        </ButtonEl>
    )
}

export default Button